import { Component, inject, OnInit } from '@angular/core';
import { SortOrder } from '@modules/common/types/sort-order';
import { NotesListStateService } from '@modules/notes/services/notes-list-state.service';
import { NotesService } from '@modules/notes/services/notes.service';
import { Note } from '@modules/notes/types/note';
import { NotesFilters } from '@modules/notes/types/notes-filters';
import { NotesListState } from '@modules/notes/types/notes-list-state';
import { KnowledgeStitchSectionComponent } from '../stitch-section/stitch-section.component';

@Component({
  selector: 'app-knowledge-notes-section',
  templateUrl: './notes-section.component.html',
  styleUrls: ['../stitch-section/stitch-section.component.less'],
  standalone: false,
  providers: [
    ...NotesListStateService.providers({
      defaultSort: {
        by: 'score',
        order: SortOrder.DESC,
      },
    }),
  ],
})
export class KnowledgeNotesSectionComponent
  extends KnowledgeStitchSectionComponent<Note, NotesFilters>
  implements OnInit
{
  protected readonly listStateService = inject(NotesListStateService, { self: true });
  protected readonly stitchService = inject(NotesService);

  ngOnInit() {
    this.state = new NotesFilters({ withEmpty: true });
    super.ngOnInit();
  }

  handleFilter(listState: NotesListState) {
    this.filterChange.emit();

    // Read directly, not streamed: handleFilter only runs on a user action, which is always after
    // the space settings have loaded, so the zone is already the account's (SBUX-829).
    this.filters = new NotesFilters({ displayTimeZone: this.displayTimeZoneService.timeZone() });
    this.filters.applyListState(listState);

    this.updateFilters();
  }
}
